<template>
	<div class="side-panel" :class="{ opened }">
		<div
			class="panel-overlay"
			@click="close"
		/>
		<div class="left-bar-width" />
		<div class="panel">
			<div class="left-bar" @click="toggle">
				<div class="fold-btn no-select">
					<div class="material-icons-outlined arrow">
						navigate_next
					</div>
				</div>
			</div>
			<div class="panel-content">
				<div class="panel-header">
					<slot name="header" />
				</div>
				<div class="divider" />
				<div class="panel-body">
					<slot name="body" />
				</div>
				<div class="panel-footer">
					<slot name="footer" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'side-panel',
	data() {
		return {
			opened: false
		};
	},
	methods: {
		open() {
			this.opened = true;
		},
		close() {
			this.opened = false;
		},
		toggle() {
			this.opened = !this.opened;
		}
	}
};
</script>

<style lang="scss">
:root {
	--side-panel-width: 360px;
	@media (max-width: 360px) {
		--side-panel-width: 100%;
	}
	--side-panel-body-width: calc(var(--side-panel-width) - var(--closed-side-panel-width));
}
.side-panel {
	.panel-overlay {
		@media (min-width: 1280px) {
			display: none;
		}
		position: fixed;
		z-index: 5;
		inset: 0;
		cursor: pointer;
		background: rgba(0, 0, 0, 0.3);
		transition: all 0.3s;
	}
	.left-bar-width {
		width: var(--closed-side-panel-width);
	}
	.panel {
		width: var(--side-panel-width);
		height: 100%;
		background: var(--gray-blue);
		transition: all 0.3s;
		z-index: 6;
		@media (max-width: 767px) {
			width: 100%;
		}
		@media (max-width: 1279px) {
			position: fixed;
			top: 0;
			right: 0;
		}
		display: flex;
		.left-bar {
			width: var(--closed-side-panel-width);
			background-color: var(--darker-blue);
			background-image: linear-gradient(315deg, var(--darker-blue) 0%, var(--blue) 74%, var(--darker-blue) 100%);
			background-size: 90%;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			cursor: pointer;
			text-shadow: 0px 0px 4px #698596;
			@media (min-width: 1280px) {
				cursor: default;
				pointer-events: none;
				display: none;
			}
			.fold-btn {
				height: 30px;
				width: 30px;
				color: #698596;
				display: flex;
				align-items: center;
				justify-content: center;
				> .arrow {
					font-size: 50px;
					transform: rotate(-180deg);
					transition: all 0.5s;
					-webkit-text-stroke: 2px rgba(255,255,255,0.6);
					color: white;
				}
			}
		}
		.panel-content {
			min-width: var(--side-panel-body-width);
			flex: auto;
			height: 100%;
			display: flex;
			flex-direction: column;
			@media (min-width: 1280px) {
				border-right: 1px solid white;
			}
			.panel-header {
				text-transform: uppercase;
				font-weight: bolder;
				font-size: 28px;
				display: flex;
				justify-content: center;
				align-items: center;
				color: white;
				height: 50px;
				min-height: 50px;
				@media (max-width: 360px) {
					font-size: 20px;
				}
			}
			.panel-body {
				flex: auto;
				background: var(--dark-blue);
				overflow: hidden;
			}
			.panel-footer {

			}
		}
	}
	@media (max-width: 1279px) {
		&:not(.opened) {
			.panel-overlay {
				width: 0;
				height: 0;
				background: rgba(0, 0, 0, 0);
			}
			.panel {
				width: var(--closed-side-panel-width);
				.left-bar {
					// background-color: #0d324d;
					// background-image: linear-gradient(315deg, #0d324d 0%, #7f5a83 74%);
					.fold-btn {
						.arrow {
							transform: rotate(0deg);
						}
					}
				}
				.panel-content {
				}
			}
		}
	}
	@media (min-width: 768px) {
	}
}
</style>
